import get from 'transmute/get';

/**
 * @description The value of the currentViewId reducer. Can be null in certain
 * situations(like while changing Inboxes).
 */
export function getCurrentViewId(state) {
  return get('currentViewId', state);
}